/**
 * View displays the user login form
 * @class
 */
import Base from '@netx/core/lib/netx-view';
import Template from '../templates/authUserLoginView.html';

import ChildView from '@netx/core-auth/views/authSamlServiceView';
import ChildViews from '@netx/core/functionality/childViews';

import Form from '@netx/core/functionality/form';

export default class AuthUserLoginView extends Base {
	/** @override */
	unsavedChanges() {
		return false;
	}

	/** @override */
	constructor(opts = {}) {
		// Do we have SAML endpoints?
		const samlEnabled =
			opts.collection && opts.collection.findWhere({type: 'saml'}) != null;
		if (samlEnabled) {
			opts.events = {
				'click .nx-saml': 'samlServiceClicked',
				'click .nx-standard': 'standardLoginClicked',
				...opts.events,
			};
			opts.childView = {
				viewClass: ChildView,
				...opts.childView,
			};
		}

		opts.eventStr = opts.eventStr || 'auth:user:login';
		opts.id = opts.id || 'user-login-view';
		opts.removeOnHide = opts.removeOnHide !== false;
		opts.removeOnSimpleHide = opts.removeOnSimpleHide !== false;
		opts.template = opts.template || Template;
		super(opts);

		if (samlEnabled) {
			// toggles standard login with SSO
			this.$el.addClass('saml-enabled');
		}
	}

	/** @override */
	bindModelEvents() {
		super.bindModelEvents();
		return this.listenTo(this.model, 'change:loginMsg', this.debouncedRender);
	}

	/** @override */
	postRender() {
		super.postRender();

		// Cache
		this.$password = this.$el.find('#password');
		this.$username = this.$el.find('#username');
	}

	/** @override */
	afterShown(view) {
		super.afterShown(view);

		this.rendered.then(this.focus);
	}

	/** @override */
	focus() {
		this.inputs.$username.focus();
	}

	/**
	 * @override
	 * @param {event} e Submit event
	 */
	submit(e) {
		// drag and drop functionality requires a
		// click event somewhere in document to remove focus
		this.$password.blur();

		super.submit(e);
	}

	/**
	 * @method
	 * @fires module:auth#auth:user:saml:navigate
	 */
	samlServiceClicked(e) {
		// saml endpoint selected
		dispatcher.trigger(
			'auth:user:saml:navigate',
			this.$(e.currentTarget).find('.nx-samlButton').attr('name'),
		);
	}

	/**
	 * @method
	 */
	standardLoginClicked(e) {
		// show standard login
		this.$el.addClass('standard-enabled');
	}

	/** @type {string} */
	static get __name__() {
		return 'AuthUserLoginView';
	}
}

// Functionality
ChildViews(AuthUserLoginView);
Form(AuthUserLoginView);
